export const managerTranslationKeys = {
  managerDaysWork: 'manager.days-work',
}
